import React, { useState } from 'react';
import CyberCard from '../components/CyberCard';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMonitor, FiBell, FiShield, FiDatabase } = FiIcons;

export default function Settings() {
  const [toggles, setToggles] = useState({
    hardMode: true,
    autoStart: false,
    soundAlerts: true,
    dataSync: true
  });

  const handleToggle = (key) => {
    setToggles(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl font-light text-[#F4F1EA] mb-2">System Configuration</h1>
        <p className="text-[#8A95A5] font-mono-cyber text-sm">ADJUST OPERATING PARAMETERS.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <CyberCard title="Focus Engine" action={<SafeIcon icon={FiMonitor} className="text-[#8A95A5]" />}>
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-[#F4F1EA]">Hard Mode</div>
                <div className="text-sm text-[#8A95A5]">Disable pausing during active sessions</div>
              </div>
              <button 
                onClick={() => handleToggle('hardMode')}
                className={`w-12 h-6 rounded-full transition-colors relative ${toggles.hardMode ? 'bg-[#00F0FF]/30' : 'bg-[#1A233A]'}`}
              >
                <div className={`absolute top-1 w-4 h-4 rounded-full transition-transform ${toggles.hardMode ? 'bg-[#00F0FF] translate-x-7 laser-glow' : 'bg-[#8A95A5] translate-x-1'}`} />
              </button>
            </div>
            
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-[#F4F1EA]">Auto-flow</div>
                <div className="text-sm text-[#8A95A5]">Start next session automatically after break</div>
              </div>
              <button 
                onClick={() => handleToggle('autoStart')}
                className={`w-12 h-6 rounded-full transition-colors relative ${toggles.autoStart ? 'bg-[#00F0FF]/30' : 'bg-[#1A233A]'}`}
              >
                <div className={`absolute top-1 w-4 h-4 rounded-full transition-transform ${toggles.autoStart ? 'bg-[#00F0FF] translate-x-7 laser-glow' : 'bg-[#8A95A5] translate-x-1'}`} />
              </button>
            </div>
          </div>
        </CyberCard>

        <CyberCard title="Notifications" action={<SafeIcon icon={FiBell} className="text-[#8A95A5]" />}>
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-[#F4F1EA]">Audio Cues</div>
                <div className="text-sm text-[#8A95A5]">Play futuristic ping on session end</div>
              </div>
              <button 
                onClick={() => handleToggle('soundAlerts')}
                className={`w-12 h-6 rounded-full transition-colors relative ${toggles.soundAlerts ? 'bg-[#00F0FF]/30' : 'bg-[#1A233A]'}`}
              >
                <div className={`absolute top-1 w-4 h-4 rounded-full transition-transform ${toggles.soundAlerts ? 'bg-[#00F0FF] translate-x-7 laser-glow' : 'bg-[#8A95A5] translate-x-1'}`} />
              </button>
            </div>
          </div>
        </CyberCard>

        <CyberCard title="Data & Privacy" action={<SafeIcon icon={FiShield} className="text-[#8A95A5]" />}>
           <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-medium text-[#F4F1EA]">Cloud Sync</div>
                <div className="text-sm text-[#8A95A5]">Encrypt and backup stats securely</div>
              </div>
              <button 
                onClick={() => handleToggle('dataSync')}
                className={`w-12 h-6 rounded-full transition-colors relative ${toggles.dataSync ? 'bg-[#00F0FF]/30' : 'bg-[#1A233A]'}`}
              >
                <div className={`absolute top-1 w-4 h-4 rounded-full transition-transform ${toggles.dataSync ? 'bg-[#00F0FF] translate-x-7 laser-glow' : 'bg-[#8A95A5] translate-x-1'}`} />
              </button>
            </div>
            
            <div className="pt-4 border-t border-[#1A233A]">
               <button className="text-sm text-red-400 hover:text-red-300 transition-colors flex items-center gap-2">
                 <SafeIcon icon={FiDatabase} />
                 Purge Local Data Cache
               </button>
            </div>
          </div>
        </CyberCard>
      </div>

      {/* Required Footer Credit */}
      <div className="mt-12 text-center py-6 border-t border-[#1A233A]/50">
        <p className="text-xs text-[#4A5568] tracking-widest uppercase font-mono-cyber">
          Made by LingLink AI and DigLab AI
        </p>
      </div>
    </div>
  );
}